export const settingsStore = {
    state: () => ({
        client: {
            chartType: 0,
            cameraApiAddress: 'localhost',
            cameraAddressScheme: 0,
            cameraApiAddressPort: 5000,
            autoEndVotingAfterAllVoted: false,
            autoGoToNextVotingAfterSave: false,
            autoStartNextVoting: false,
            autoStartNextVotingTime: 3,
            rememberVotingMode: false,
            rememberVotingModeValue: 1,
            adminVoteForUser: true,
            menuInteractiveShowQorum: true,
            interactiveModalVotingShowAvatar: true,
            interactiveModalQuorumShowAvatar: true,
            interactiveDiscussionShowAvatar: true,
            clientLogoShowOw: true,
            clientLogoShowDocuments: true,
            clientFooterShowDocuments: true,
            showClockInOw: true,
            userOnlineBasedOnMicrophones: false,
            supportCalendarIntegration: false,
            displayGovernmentNews: true,
            showUserAvatarInMultiSelect: false,
            showUserAvatarInContacts: true,
            showVotingListInOw: false,
            hideDefaultFooterInEmail: false,
            dontShowWhiteBackgroundInESesjaTvOverlay: false,
        },
        user: {
            chartType: 0,
            cameraApiAddress: 'localhost',
            cameraAddressScheme: 0,
            cameraApiAddressPort: 5000,
            autoEndVotingAfterAllVoted: false,
            autoGoToNextVotingAfterSave: false,
            autoStartNextVoting: false,
            autoStartNextVotingTime: 3,
            rememberVotingMode: false,
            rememberVotingModeValue: 1,
            adminVoteForUser: true,
            menuInteractiveShowQorum: true,
            interactiveModalVotingShowAvatar: true,
            interactiveModalQuorumShowAvatar: true,
            interactiveDiscussionShowAvatar: true,
            clientLogoShowOw: true,
            clientLogoShowDocuments: true,
            clientFooterShowDocuments: true,
            showClockInOw: true,
            userOnlineBasedOnMicrophones: false,
            supportCalendarIntegration: false,
            displayGovernmentNews: true,
            showUserAvatarInMultiSelect: false,
            showUserAvatarInContacts: true,
            showVotingListInOw: false,
            hideDefaultFooterInEmail: false,
            dontShowWhiteBackgroundInESesjaTvOverlay: false,
        },
        runtime: {
            chartType: 0,
            cameraApiAddress: 'localhost',
            cameraAddressScheme: 0,
            cameraApiAddressPort: 5000,
            autoEndVotingAfterAllVoted: false,
            autoGoToNextVotingAfterSave: false,
            autoStartNextVoting: false,
            autoStartNextVotingTime: 3,
            rememberVotingMode: false,
            rememberVotingModeValue: 1,
            adminVoteForUser: true,
            menuInteractiveShowQorum: true,
            interactiveModalVotingShowAvatar: true,
            interactiveModalQuorumShowAvatar: true,
            interactiveDiscussionShowAvatar: true,
            clientLogoShowOw: true,
            clientLogoShowDocuments: true,
            clientFooterShowDocuments: true,
            showClockInOw: true,
            userOnlineBasedOnMicrophones: false,
            supportCalendarIntegration: false,
            displayGovernmentNews: true,
            showUserAvatarInMultiSelect: false,
            showUserAvatarInContacts: true,
            showVotingListInOw: false,
            hideDefaultFooterInEmail: false,
            dontShowWhiteBackgroundInESesjaTvOverlay: false,
        },
        allowIpAddress: '',
        logoBase64: '',
        cadenceYears: '-'
    }),
    mutations: {
        setClientSettings(state, status) {
            state.client = status;
        },

        setUserSettings(state, status){
            state.user = status;
        },

        setRuntimeSettings(state, status){
            state.runtime = status;
        },

        setVotingsChartType(state, status) {
            state.client.chartType = status;
            state.runtime.chartType = status;
        },

        seCameraApiAddress(state, status) {
            state.client.cameraApiAddress = status;
        },

        setAllowIpAddress(state, ipAddress){
            state.allowIpAddress = ipAddress
        },

        setLogoBase64(state, status) {
            state.logoBase64 = status;
        },

        setCadenceYears(state, status) {
            state.cadenceYears = status;
        },
    }
}